import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/contract_revision/{contract_revision_id}/invoice_headers
export const invoiceList = async (contractRevisionId: number) => {
  const response = await new Request().get(
    '/ajax/contract_revision/' + contractRevisionId + '/invoice_headers'
  )
  return Util.Obj.keysToCamel(response.data.invoice_headers)
}
